/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CreateEvalSuiteVersionRequest = {
  suiteId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  createEvalSuiteVersionRequest: components.CreateEvalSuiteVersionRequest;
};

export type Manifest = {
  schemaVersion?: string | undefined;
  tasks: Array<any | null>;
  metadata?: { [k: string]: any } | undefined;
};

/**
 * OK
 */
export type CreateEvalSuiteVersionResponseBody = {
  id: string;
  object: "eval.suite.version";
  suiteId: string;
  version: number;
  manifest: Manifest;
  datasetFileIds: Array<string>;
  metadata: { [k: string]: string };
  createdAt: number;
};

/** @internal */
export const CreateEvalSuiteVersionRequest$inboundSchema: z.ZodType<
  CreateEvalSuiteVersionRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  suite_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
  CreateEvalSuiteVersionRequest:
    components.CreateEvalSuiteVersionRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "suite_id": "suiteId",
    "X-On-Behalf-Of": "xOnBehalfOf",
    "CreateEvalSuiteVersionRequest": "createEvalSuiteVersionRequest",
  });
});
/** @internal */
export type CreateEvalSuiteVersionRequest$Outbound = {
  suite_id: string;
  "X-On-Behalf-Of"?: string | undefined;
  CreateEvalSuiteVersionRequest:
    components.CreateEvalSuiteVersionRequest$Outbound;
};

/** @internal */
export const CreateEvalSuiteVersionRequest$outboundSchema: z.ZodType<
  CreateEvalSuiteVersionRequest$Outbound,
  z.ZodTypeDef,
  CreateEvalSuiteVersionRequest
> = z.object({
  suiteId: z.string(),
  xOnBehalfOf: z.string().optional(),
  createEvalSuiteVersionRequest:
    components.CreateEvalSuiteVersionRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    suiteId: "suite_id",
    xOnBehalfOf: "X-On-Behalf-Of",
    createEvalSuiteVersionRequest: "CreateEvalSuiteVersionRequest",
  });
});

export function createEvalSuiteVersionRequestToJSON(
  createEvalSuiteVersionRequest: CreateEvalSuiteVersionRequest,
): string {
  return JSON.stringify(
    CreateEvalSuiteVersionRequest$outboundSchema.parse(
      createEvalSuiteVersionRequest,
    ),
  );
}
export function createEvalSuiteVersionRequestFromJSON(
  jsonString: string,
): SafeParseResult<CreateEvalSuiteVersionRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateEvalSuiteVersionRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateEvalSuiteVersionRequest' from JSON`,
  );
}

/** @internal */
export const Manifest$inboundSchema: z.ZodType<
  Manifest,
  z.ZodTypeDef,
  unknown
> = z.object({
  schema_version: z.string().default("2026-05-27"),
  tasks: z.array(z.nullable(z.any())),
  metadata: z.record(z.any()).optional(),
}).transform((v) => {
  return remap$(v, {
    "schema_version": "schemaVersion",
  });
});
/** @internal */
export type Manifest$Outbound = {
  schema_version: string;
  tasks: Array<any | null>;
  metadata?: { [k: string]: any } | undefined;
};

/** @internal */
export const Manifest$outboundSchema: z.ZodType<
  Manifest$Outbound,
  z.ZodTypeDef,
  Manifest
> = z.object({
  schemaVersion: z.string().default("2026-05-27"),
  tasks: z.array(z.nullable(z.any())),
  metadata: z.record(z.any()).optional(),
}).transform((v) => {
  return remap$(v, {
    schemaVersion: "schema_version",
  });
});

export function manifestToJSON(manifest: Manifest): string {
  return JSON.stringify(Manifest$outboundSchema.parse(manifest));
}
export function manifestFromJSON(
  jsonString: string,
): SafeParseResult<Manifest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Manifest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Manifest' from JSON`,
  );
}

/** @internal */
export const CreateEvalSuiteVersionResponseBody$inboundSchema: z.ZodType<
  CreateEvalSuiteVersionResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  object: z.literal("eval.suite.version"),
  suite_id: z.string(),
  version: z.number().int(),
  manifest: z.lazy(() => Manifest$inboundSchema),
  dataset_file_ids: z.array(z.string()),
  metadata: z.record(z.string()),
  created_at: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    "suite_id": "suiteId",
    "dataset_file_ids": "datasetFileIds",
    "created_at": "createdAt",
  });
});
/** @internal */
export type CreateEvalSuiteVersionResponseBody$Outbound = {
  id: string;
  object: "eval.suite.version";
  suite_id: string;
  version: number;
  manifest: Manifest$Outbound;
  dataset_file_ids: Array<string>;
  metadata: { [k: string]: string };
  created_at: number;
};

/** @internal */
export const CreateEvalSuiteVersionResponseBody$outboundSchema: z.ZodType<
  CreateEvalSuiteVersionResponseBody$Outbound,
  z.ZodTypeDef,
  CreateEvalSuiteVersionResponseBody
> = z.object({
  id: z.string(),
  object: z.literal("eval.suite.version"),
  suiteId: z.string(),
  version: z.number().int(),
  manifest: z.lazy(() => Manifest$outboundSchema),
  datasetFileIds: z.array(z.string()),
  metadata: z.record(z.string()),
  createdAt: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    suiteId: "suite_id",
    datasetFileIds: "dataset_file_ids",
    createdAt: "created_at",
  });
});

export function createEvalSuiteVersionResponseBodyToJSON(
  createEvalSuiteVersionResponseBody: CreateEvalSuiteVersionResponseBody,
): string {
  return JSON.stringify(
    CreateEvalSuiteVersionResponseBody$outboundSchema.parse(
      createEvalSuiteVersionResponseBody,
    ),
  );
}
export function createEvalSuiteVersionResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<CreateEvalSuiteVersionResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      CreateEvalSuiteVersionResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateEvalSuiteVersionResponseBody' from JSON`,
  );
}
